import api from "@/api.js";
import suppliers from "./suppliers";
import impact from "./impact";
import outcomeAccess from "./outcomeAccess";

export default {
  namespaced: true,
  modules: {
    suppliers,
    impact,
    outcomeAccess,
  },
  state: {
    list: [],
    listLoading: false,
    otherBusinessList: [],
    otherBusinessListLoading: false,
    current: null,
    currentLoading: false,
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setOtherBusinessList(state, payload) {
      state.otherBusinessList = payload;
    },
    setOtherBusinessListLoading(state, payload) {
      state.otherBusinessListLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },

    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("sustainability/business/all");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadAllOther({ commit }) {
      commit("setOtherBusinessListLoading", true);
      let list = await api.get("sustainability/business/allOther");
      commit("setOtherBusinessList", list.data);
      commit("setOtherBusinessListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("sustainability/business/byID", {
        params: { id: id },
      });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async loadAuthenticated({ commit }) {
      commit("setCurrentLoading", true);
      let response = await api.get("sustainability/business");
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("sustainability/business", payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: err,
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};

      await api
        .put(`sustainability/business`, payload)
        .then((response) => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data,
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async updateLogo({ dispatch }, payload) {
      let returnData = {};

      await api
        .post(`sustainability/business/updateLogo`, payload)
        .then((result) => {
          if (result.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: result.data,
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: "There was an Error, Please try again later",
            };
          }
        })
        .catch((err) => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later",
            },
          };
        });

      dispatch("loadAuthenticated");
      return returnData;
    },
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    otherBusinessList(state) {
      console.log(state.otherBusinessList);
      return state.otherBusinessList
        .filter((v) => v.name)
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    otherBusinessListLoading(state) {
      return state.otherBusinessListLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
  },
};
